module.exports = __webpack_public_path__ + "static/media/menu_scheduling.30d373c0.svg";